export const enum LOGIN_BY {
  CODE = 'code',
  PASSWORD = 'password',
}

type Props = {
  loginBy: LOGIN_BY;
};
export default Props;
